<template>
  <v-menu offset-y tile nudge-bottom="10" min-width="200" :content-class="isHome ? '' : 'fixed'">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        plain
        small
        rounded
        class="subtitle-1 pa-2"
        :class="isHome ? 'white--text' : 'black--text'"
        v-bind="attrs"
        v-on="on"
      >{{ languageCode }} <v-icon class="ml-1">fas fa-caret-down fa-sm</v-icon>
      </v-btn>
    </template>
    <v-list :elevation="0">
      <v-list-item-group
          v-model="currentLanguage"
          color="primary"
          @change="switchLanguage"
        >
        <v-list-item
          dense
          class="pointer"
          v-for="language in languages"
          :key="language.id"
          :value="language.id"
        >
          <v-list-item-icon class="mr-4">
            <v-img width="40" :src="language.url"></v-img>
          </v-list-item-icon>
          <v-list-item-content class="elevation-0">
            {{ language.name }}
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
import Storage from "@/utils/storage";
export default {
  name: 'SwitchLanguage',
  data() {
    return {
      currentLanguage: null
    }
  },
  computed: {
    languages() {
      return Object.keys(this.$language.available).map(language => {
        let name = null
        switch (language) {
          case 'en_EN':
            name = this.$gettext("English");break;
          case 'fr_FR':
            name = this.$gettext("France");break;
          case 'vi_VN':
            name = this.$gettext("Vietnam");break;
          case 'it_IT':
            name = this.$gettext("Italian");break;
          case 'de_DE':
            name = this.$gettext("German");break;
          case 'es_US':
            name = this.$gettext("Spanish");break;
        }
        return {
          id: language,
          name,
          url: this.iconUrl('icon-flag-' + language.split('_')[1].toLowerCase() + '.png')
        }
      })
    },
    languageCode() {
      const code = this.$language.current.split('_')[1];
      return code == 'US' ? 'ES' : code;
    },
    isHome() {
      if(this.$route.name === 'homepage') return true;
      if(this.$route.name.indexOf('ranking') !== -1) return true;
      return false;
    }
  },
  methods: {
    switchLanguage() {
      Storage.set('currentLanguage', this.currentLanguage);
      this.$language.current = this.currentLanguage
      this.$store.dispatch("fetchAvailableZoneAndCountry", true);
      if(!window.cordova) {
        //this.$router.go()
      }
    }
  },
  mounted() {
    this.currentLanguage = this.$language.current
  }
};
</script>
<style lang="scss">
.areaBlock__col {
  &:hover {
    color: var(--color-hover);
  }
}
</style>